<template>
    <div class="advanced-box">
        <slot name="content"></slot>
        <div
            class="more-container"
            :style="moreContainerStyles"
            :class="{ visible: showMore, hidden: !showMore }"
        >
            <div
                ref="moreContentWrapper"
                class="more-content-wrapper"
                :class="{ visible: showMore, hidden: !showMore }"
            >
                <slot name="more-content"></slot>
            </div>
        </div>
        <div class="btn toggle-more" @click="toggleMore">
            {{ toggleMoreLabel }}
            <span class="toggle-more__arrow-container">
                <img
                    src="../assets/icons/arrow-more.svg"
                    alt="toggle more"
                    class="toggle-more__arrow"
                    :class="{ up: showMore }"
                />
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'AdvancedBox',
        data: function () {
            return {
                showMore: false,
                moreContainerStyles: {
                    height: 0,
                },
            };
        },
        computed: {
            toggleMoreLabel: function () {
                return this.showMore ? 'zwiń' : 'rozwiń';
            },
        },
        methods: {
            toggleMore: function () {
                this.showMore = !this.showMore;
                if (this.showMore) {
                    this.openMore();
                } else {
                    this.closeMore();
                }
            },
            openMore: function () {
                const contentHeight = this.$refs.moreContentWrapper.clientHeight;
                this.moreContainerStyles.height = contentHeight + 'px';
            },
            closeMore: function () {
                this.moreContainerStyles.height = 0;
            },
        },
    };
</script>

<style lang="scss">
    @import '../scss/embed-wrapper';

    .advanced-box {
        width: calc(100% - #{$margin * 4});
        border-radius: 15px;
        margin-left: $margin;
        margin-right: $margin;
        margin-bottom: 10px;
        padding: $margin;
        background-color: $green;
        color: $light-green;
        text-align: left;

        .more-container {
            overflow: hidden;
            transition: height 0.3s ease-out;

            &.hidden {
                transition-delay: 0.1s;
                pointer-events: none;
                touch-action: none;
            }

            &.visible {
                transition-delay: 0s;
            }
        }

        .more-content-wrapper {
            transition: opacity 0.2s ease-in;
            z-index: 1;

            &.hidden {
                opacity: 0;
                transition-delay: 0s;
            }

            &.visible {
                opacity: 1;
                transition-delay: 0.1s;
            }
        }

        .toggle-more {
            font-size: 14px;
            margin-top: 20px;
            z-index: 100;

            &__arrow-container {
                position: relative;
                left: 2px;
                top: -1px;
            }

            &__arrow {
                width: 10px;
                transform-origin: 50% 50%;
                transition: transform 0.3s;

                &.up {
                    transform: rotate(-180deg);
                }
            }
        }

        a {
            color: $light-green;
            word-break: break-all;
        }
    }
</style>
